// src/components/TracksPage.js

import React from 'react';
import './TracksPage.css';

import mindMattersImg from './images/Tracks/Mind Matters.png';
import financeForwardImg from './images/Tracks/FinanceForward.png';
import artCultureImg from './images/Tracks/ArtCulture.png';

const tracks = [
  { name: 'Mind Matters', image: mindMattersImg },
  { name: 'Finance Forward', image: financeForwardImg },
  { name: 'Art & Culture', image: artCultureImg },
];

export default function TracksPage() {
  return (
    <section className="tracks-page">
      <h2 className="tracks-title">TRACKS</h2>
      <div className="tracks-grid">
        {tracks.map((track) => (
          <div className="track-item" key={track.name}>
            <img src={track.image} alt={track.name} className="track-icon" />
          </div>
        ))}
      </div>
    </section>
  );
}
